module.exports = __webpack_public_path__ + "static/img/2.a0b5dd83.jpg";